import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import moment from "moment";
import { Card, Modal } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Table from 'react-bootstrap/Table'
import { clearTableData, fetchCreditManagementInputData, sendCrMgtAdjEntryData } from './dispatch';
import DatePicker from "react-datepicker";

const AdjustmentEntry = (props) => {
    const data = JSON.parse(localStorage.getItem("USER_DETAILS"));
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [meterId, setMeterId] = useState('');
    const [creditManagementFormData, setCreditManagementFormData] = useState({});
    const [errorsMasterValue, setErrorsMasterValue] = useState({});
    const { creditManagementInputData } = useSelector(state => state.creditManagementReducer); // customer number, consumer name, meter number, meter id
    const { creditManagementAdjEntryTableData, isCreditManagementDataLoading } = useSelector(state => state.creditManagementReducer); // table data

    useEffect(() => {
        if (data) {
            //to get payment source, payment mode and payment type
            dispatch(fetchCreditManagementInputData({
                "userName": data?.pDATASET[0]?.USERNAME,
                "apiID": 3,
                "param1": 0,
                "param2": 0,
                "param3": 0,
                "param4": "",
                "param5": "",
                "param6": ""
            }, data.token));
        }

    }, [dispatch]);

    const handleChange = (event, param) => {
        creditManagementFormData.CustomerNumber = '';
        let name = event?.target?.name;
        let value = event?.target?.value;
        setMeterId('');
        if (name == 'ConsumerNumber' && value.length >= 1 && data) {
            if (data) {
                //to get custome name, customer ID, Meter ID, Meter No
                dispatch(fetchCreditManagementInputData({
                    "userName": data?.pDATASET[0]?.USERNAME,
                    "apiID": 1,
                    "param1": parseInt(value), //customer number
                    "param2": 0,
                    "param3": 0,
                    "param4": data?.pDATASET[0]?.CIRCLE_CODE,
                    "param5": "",
                    "param6": ""
                }, data.token));
            }
        }
        if (param == 'AdjDate') {
            name = param;
            value = moment(event).format("YYYY-MM-DD").toString();
            setMeterId(meterId);
        }
        if(param == 'AdjAmount' || param == 'Remark') {
            setMeterId(meterId); 
        }
        if (param == 'MeterNumber') {
            if (!value) {
                setMeterId('');
            }
            for (let i = 0; i < creditManagementInputData.length; i++) {
                if (creditManagementInputData[i].METER_NO == value) {
                    setMeterId(creditManagementInputData[i].METER_ID)
                }
            }
        }
        setCreditManagementFormData(values => ({ ...values, [name]: value }))
    }

    const validateForm = () => {
        const newErrors = {};
        if (!creditManagementFormData?.ConsumerNumber) newErrors.ConsumerNumber = 'Consumer Number is required';
        if (!creditManagementFormData?.MeterNumber) newErrors.MeterNumber = 'Meter Number is required';
        return newErrors;
    };

    const handleSubmit = () => {
        const formErrors = validateForm();
        if (Object.keys(formErrors).length > 0) {
            setErrorsMasterValue(formErrors);
        } else {
            setErrorsMasterValue({});
            if (creditManagementFormData?.ConsumerNumber?.length >= 1 && creditManagementInputData?.length > 0) {
                //to get table data
                dispatch(fetchCreditManagementInputData({
                    "userName": data?.pDATASET[0]?.USERNAME,
                    "apiID": 5,
                    "param1": parseInt(creditManagementInputData?.length > 0 && meterId != '' ? meterId : 0), //meter id
                    "param2": 0,
                    "param3": 0,
                    "param4": '',
                    "param5": '',
                    "param6": ''

                }, data.token));
            }
        }
    }

    const handleCancel = () => {
        setErrorsMasterValue({});
        setMeterId('');
        let formCancelObj = { ...creditManagementFormData };
        formCancelObj.ConsumerNumber = '';
        formCancelObj.MeterNumber = '';
        formCancelObj.AdjAmount = '';
        formCancelObj.Remark = '';
        formCancelObj.AdjDate = moment(new Date()).format("YYYY-MM-DD");
        dispatch(clearTableData(1));
        dispatch(clearTableData(5));
        setCreditManagementFormData(formCancelObj);
    }

    const validateBelowForm = () => {
        const newErrors = {};
        if (!creditManagementFormData?.ConsumerNumber) newErrors.ConsumerNumber = 'Consumer Number is required';
        if (!creditManagementFormData?.MeterNumber) newErrors.MeterNumber = 'Meter Number is required';
        if (!creditManagementFormData?.AdjAmount) newErrors.AdjAmount = 'Adjustment Amount is required';
        if (!creditManagementFormData?.Remark) newErrors.Remark = 'Remark is required';
        return newErrors;
    };

    const handleBelowSubmit = () => {
        const formErrors = validateBelowForm();
        if (Object.keys(formErrors).length > 0) {
            setErrorsMasterValue(formErrors);
        } else {
            setErrorsMasterValue({});
            //to send form data
            if (creditManagementFormData?.ConsumerNumber?.length >= 1 && creditManagementInputData?.length > 0) {
                dispatch(sendCrMgtAdjEntryData({
                    "userName": data?.pDATASET[0]?.USERNAME,
                    "apiID": "1",
                    "data": {
                        "customerNumber": parseInt(creditManagementFormData.ConsumerNumber),
                        "customerId": parseInt(creditManagementInputData[0]?.CUSTOMER_ID),
                        "meterNumber": parseInt(creditManagementFormData?.ConsumerNumber?.length >= 1 && creditManagementInputData?.length > 0 && creditManagementInputData[0]?.METER_NO ? creditManagementInputData[0]?.METER_NO : 0), //meter number
                        "circleCode": data?.pDATASET[0]?.CIRCLE_CODE,
                        "meterId": parseInt(creditManagementFormData?.ConsumerNumber?.length >= 1 && creditManagementInputData?.length > 0 && creditManagementInputData[0]?.METER_ID ? creditManagementInputData[0]?.METER_ID : 0), //meter number
                        "paymentMode": "UI-Adj",
                        "paymentType": "Adj",
                        "paymentSource": "UI",
                        "adjDate": moment(creditManagementFormData?.AdjDate).format('DD-MM-YY'),
                        "adjAmount": creditManagementFormData.AdjAmount ? creditManagementFormData.AdjAmount : '',
                        "remark": creditManagementFormData.Remark ? creditManagementFormData.Remark : '',
                    }
                }, data.token));
            }
        }
    }

    const handleBelowCancel = () => {
        setErrorsMasterValue({});
        let adjDate = new Date();
        let belowFormCancelObj = { ...creditManagementFormData };
        belowFormCancelObj.AdjDate = moment(adjDate).format("YYYY-MM-DD").toString();
        belowFormCancelObj.AdjAmount =  '';
        belowFormCancelObj.Remark = '';
        belowFormCancelObj.ConsumerName = creditManagementInputData && creditManagementInputData.length > 0 && creditManagementFormData?.ConsumerNumber?.length >= 1 ? creditManagementInputData[0]?.CUSTOMER_NAME : '';
        belowFormCancelObj.ConsumerID = creditManagementInputData && creditManagementInputData.length > 0 && creditManagementFormData?.ConsumerNumber?.length >= 1 ? creditManagementInputData[0]?.CUSTOMER_ID : '';
        setCreditManagementFormData(belowFormCancelObj);
    }

    return (
        <div className='mainContainer'>
            <Card className="titleCard">
                <Card.Body className="d-flex align-items-center">
                    <Card.Title className="titleCardTitle">
                        Adjustment Entry
                    </Card.Title>
                </Card.Body>
            </Card>
            {
                <Card className='bodyCard'>
                    <Card.Body className="p-0" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                        <>
                            <Form>
                                {
                                    (data?.pDATASET[0]?.STATE_NAME || data?.pDATASET[0]?.CIRCLE_NAME) ?
                                        <div className='bodyCardHeader'>
                                            <div style={{ marginLeft: '35px', display: 'flex', flexDirection: 'column' }}>
                                                <Form.Label className='robotoLight13 m-0'>State</Form.Label>
                                                <Form.Label className='robotoRegular15'>{data?.pDATASET[0]?.STATE_NAME}</Form.Label>
                                            </div>
                                            <div style={{ marginLeft: '75px', display: 'flex', flexDirection: 'column' }}>
                                                <Form.Label className='robotoLight13 m-0'>Distict</Form.Label>
                                                <Form.Label className='robotoRegular15'>{data?.pDATASET[0]?.CIRCLE_NAME}</Form.Label>
                                            </div>
                                        </div> : null
                                }

                                <Row className='formRow mx-0'>
                                    <Col md={3}>
                                        <Form.Group as={Col} controlId="consumerNumber" >
                                            <Form.Label className='robotoBoldRed13'>*</Form.Label>
                                            <Form.Label className='robotoLight13'>Consumer Number</Form.Label>
                                            <Form.Control placeholder="00000000" className='robotoRegular15'
                                                value={creditManagementFormData?.ConsumerNumber}
                                                name="ConsumerNumber"
                                                onChange={handleChange}
                                                isInvalid={!!errorsMasterValue.ConsumerNumber} />
                                            <div className='robotoRegularRed13'>
                                                {errorsMasterValue.ConsumerNumber}
                                            </div>
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group as={Col} controlId="consumerId" >
                                            <Form.Label className='robotoLight13'>Consumer ID</Form.Label>
                                            <Form.Control className='robotoRegular15' style={{ marginTop: '5px' }}
                                                value={creditManagementInputData && creditManagementInputData.length > 0 && creditManagementFormData?.ConsumerNumber?.length >= 1 ? creditManagementInputData[0]?.CUSTOMER_ID : ''}
                                                name="ConsumerID"
                                                disabled={true} />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group as={Col} controlId="ConsumerName" >
                                            <Form.Label className='robotoLight13'>Consumer Name</Form.Label>
                                            <Form.Control className='robotoRegular15' style={{ marginTop: '5px' }}
                                                value={creditManagementInputData && creditManagementInputData.length > 0 && creditManagementFormData?.ConsumerNumber?.length >= 1 ? creditManagementInputData[0]?.CUSTOMER_NAME : ''}
                                                name="ConsumerName"
                                                disabled={true} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className='formRow mx-0'>
                                    <Col md={3}>
                                        <Form.Group as={Col} controlId="MeterNumber">
                                            <Form.Label className='robotoLight13'>Meter Number</Form.Label>
                                            <Form.Select defaultValue="Choose..."
                                                name="MeterNumber"
                                                value={creditManagementFormData?.MeterNumber}
                                                onChange={(e) => { handleChange(e, "MeterNumber") }}
                                                className='robotoRegular15'>
                                                <option value="">Please select</option>
                                                {
                                                    creditManagementInputData?.map((item) => {
                                                        return <option value={item.CATEGORY_ID}>{item.METER_NO}</option>
                                                    })
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group as={Col} controlId="meterID" >
                                            <Form.Label className='robotoLight13'>Meter ID</Form.Label>
                                            <Form.Control className='robotoRegular15'
                                                value={meterId}
                                                name="meterID"
                                                disabled={true} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className='formBtn'>
                                    <Button variant="primary"
                                        onClick={() => { handleCancel() }}>
                                        Cancel
                                    </Button>
                                    <Button variant="primary" style={{ marginLeft: '15px' }}
                                        onClick={() => { handleSubmit() }}>
                                        Submit
                                    </Button>
                                </div>
                                <div className='tableData' style={{marginBottom: '20px'}}>
                                    {
                                        isCreditManagementDataLoading ?
                                            <Form.Label className='robotoLight13'>Loading .....</Form.Label> :
                                            creditManagementAdjEntryTableData && creditManagementAdjEntryTableData.length > 0 ?
                                                <div>
                                                    <div className='robotoRegular15' style={{ marginBottom: "10px" }}>Last 5 Payment/Adjustment View :</div>
                                                    <Table className="table table-striped table-light">
                                                        <thead>
                                                            <tr>
                                                                <th className='robotoMedium15' style={{ backgroundColor: '#FFF6D6', textAlign: 'center' }}>Payment Date</th>
                                                                <th className='robotoMedium15' style={{ backgroundColor: '#FFF6D6', textAlign: 'center' }}>Payment Mode</th>
                                                                <th className='robotoMedium15' style={{ backgroundColor: '#FFF6D6', textAlign: 'center' }}>Payment Type</th>
                                                                <th className='robotoMedium15' style={{ backgroundColor: '#FFF6D6', textAlign: 'center' }}>Payment Source</th>
                                                                <th className='robotoMedium15' style={{ backgroundColor: '#FFF6D6', textAlign: 'center' }}>Payment Amount</th>
                                                                <th className='robotoMedium15' style={{ backgroundColor: '#FFF6D6', textAlign: 'center' }}>Remarks</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {creditManagementAdjEntryTableData?.map((listValue, index) => {
                                                                return (
                                                                    index < 5 ?
                                                                        <tr key={index}>
                                                                            <td className='robotoRegular15' style={{ textAlign: 'center' }}>{moment(listValue?.PAYMENT_DATE).format('YYYY-MM-DD HH:mm')}</td>
                                                                            <td className='robotoRegular15' style={{ textAlign: 'center' }}>{listValue?.PAYMENT_MODE}</td>
                                                                            <td className='robotoRegular15' style={{ textAlign: 'center' }}>{listValue?.PAYMENT_TYPE}</td>
                                                                            <td className='robotoRegular15' style={{ textAlign: 'center' }}>{listValue?.PAYMNET_SOURCE}</td>
                                                                            <td className='robotoRegular15' style={{ textAlign: 'center' }}>{listValue?.PAYMENT_AMOUNT}</td>
                                                                            <td className='robotoRegular15' style={{ textAlign: 'center' }}>{listValue?.PAYMENT_REMARKS}</td>
                                                                        </tr> : null
                                                                );
                                                            })}
                                                        </tbody>
                                                    </Table>
                                                </div> : creditManagementAdjEntryTableData?.length == 0 ? <div className='robotoRegular15' style={{ textAlign: 'center' }}>No Records Found!!</div> : null
                                    }
                                </div>
                                <Row className='formRow mx-0'>
                                    <Col md={2}>
                                        <Form.Group as={Col} controlId="paymentMode" >
                                            <Form.Label className='robotoLight13'>Payment Mode</Form.Label>
                                            <Form.Control placeholder="UI-Adj" style={{ width: '100%' }}
                                                name="paymentMode"
                                                onChange={handleChange}
                                                disabled={true}
                                                className='robotoRegular15' />
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Group as={Col} controlId="PaymentType" >
                                            <Form.Label className='robotoLight13'>Payment Type</Form.Label>
                                            <Form.Control placeholder="Adj" style={{ width: '100%' }}
                                                name="PaymentType"
                                                disabled={true}
                                                className='robotoRegular15' />
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Group as={Col} controlId="PaymentSource" >
                                            <Form.Label className='robotoLight13'>Payment Source</Form.Label>
                                            <Form.Control placeholder="UI" style={{ width: '100%' }}
                                                name="PaymentSource"
                                                disabled={true}
                                                className='robotoRegular15' />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form >
                                            <label className='robotoBoldRed13'>*</label>
                                            <label className='robotoLight13'>Adj Date</label>
                                            <Modal.Body style={{ marginTop: '8px' }}>
                                                <DatePicker
                                                    className='robotoRegular15'
                                                    maxDate={moment().toDate()}
                                                    dateFormat="yyyy/MM/dd"
                                                    selected={moment(creditManagementFormData?.AdjDate).format("YYYY-MM-DD")}
                                                    onChange={(date) => handleChange(date, 'AdjDate')}
                                                    icon={<img src={require('../../assets/calender.png')} style={{ paddingLeft: '10px', right: 5, width: 20, height: 20 }} onClick={() => setOpen(!open)} />}
                                                    showIcon
                                                    isInvalid={!!errorsMasterValue.AdjDate} />
                                            </Modal.Body>
                                            <div className='robotoRegularRed13'>
                                                {errorsMasterValue.AdjDate}
                                            </div>
                                        </Form>
                                    </Col>
                                </Row>
                                <Row className='formRow mx-0'>
                                    <Col md={3}>
                                        <Form.Group as={Col} controlId="adjAmount" >
                                            <Form.Label className='robotoBoldRed13'>*</Form.Label>
                                            <Form.Label className='robotoLight13'>Adj Amount</Form.Label>
                                            <Form.Control style={{ width: '100%' }}
                                                className='robotoRegular15'
                                                value={creditManagementFormData?.AdjAmount}
                                                name="AdjAmount"
                                                onChange={(e)=> handleChange(e, 'AdjAmount')}
                                                isInvalid={!!errorsMasterValue.AdjAmount} />
                                            <div className='robotoRegularRed13'>
                                                {errorsMasterValue.AdjAmount}
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group as={Col} controlId="remark" >
                                            <Form.Label className='robotoBoldRed13'>*</Form.Label>
                                            <Form.Label className='robotoLight13'>Remark</Form.Label>
                                            <Form.Control style={{ width: '100%' }}
                                                className='robotoRegular15'
                                                value={creditManagementFormData?.Remark}
                                                name="Remark"
                                                onChange={(e)=> handleChange(e, 'Remark')}
                                                isInvalid={!!errorsMasterValue.Remark} />
                                            <div className='robotoRegularRed13'>
                                                {errorsMasterValue.Remark}
                                            </div>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className='formBtn'>
                                    <Button variant="primary"
                                        onClick={() => { handleBelowCancel() }}>
                                        Cancel
                                    </Button>
                                    <Button variant="primary" style={{ marginLeft: '15px' }}
                                        onClick={() => { handleBelowSubmit() }}>
                                        Submit
                                    </Button>
                                </div>
                            </Form>
                        </>
                    </Card.Body>
                </Card>
            }
        </div>
    );
}

export default AdjustmentEntry;
